var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97001 0.470002C7.11087 0.335891 7.29833 0.261749 7.49282 0.26322C7.68732 0.264692 7.87363 0.341662 8.01245 0.47789C8.15127 0.614117 8.23175 0.798946 8.23689 0.993376C8.24203 1.18781 8.17143 1.37663 8.04001 1.52L4.05001 6.51C3.9814 6.5839 3.89859 6.6432 3.80654 6.68437C3.71448 6.72553 3.61508 6.74771 3.51426 6.74958C3.41344 6.75145 3.31328 6.73296 3.21976 6.69523C3.12625 6.65751 3.0413 6.60131 2.97001 6.53L0.324005 3.884C0.250318 3.81534 0.191216 3.73254 0.150224 3.64054C0.109232 3.54854 0.0871901 3.44923 0.0854134 3.34852C0.0836366 3.24782 0.102161 3.14779 0.139882 3.0544C0.177603 2.96102 0.233748 2.87618 0.304967 2.80496C0.376186 2.73374 0.461019 2.6776 0.554407 2.63988C0.647796 2.60216 0.747825 2.58363 0.848528 2.58541C0.949231 2.58719 1.04854 2.60923 1.14054 2.65022C1.23254 2.69121 1.31534 2.75031 1.384 2.824L3.47801 4.917L6.95101 0.492002C6.95726 0.484303 6.96393 0.476958 6.971 0.470002H6.97001Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6ad86605a752ac223bd34b81399dc34b.svg";
export { ForwardRef as ReactComponent };